import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const InstantQuote = (props) => {
  const {
    loading,
    className,
    label,
    onQuoteRequest,
  } = props;

  const text = loading ? Spree.translations.loading : label;

  return (
    <div className="w-100">
      <button
        type="button"
        className={classnames('btn btn-primary w-100 btn-quote', loading && 'disabled', className)}
        onClick={onQuoteRequest}
        disabled={loading}>
        {loading && <span className="spinner-border spinner-border-sm mr-2" aria-hidden="true" />}
        {text}
      </button>
    </div>
  );
};

InstantQuote.defaultProps = {
  className: 'btn btn-main-action',
  loading: false,
  label: Spree.translations.quote,
};

InstantQuote.propTypes = {
  loading: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  onQuoteRequest: PropTypes.func.isRequired,
};

export default InstantQuote;
